import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, ShieldCheck } from 'lucide-react';
import { AUTH } from '@/constants/testIds';
import { R } from '@/lib/routes';
import { useAuth } from '@/context/AuthContext';

const LOGIN_BG = 'https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwYnVpbGRpbmclMjBleHRlcmlvciUyMGRheXxlbnwwfHx8fDE3ODU5NTEzMTJ8MA&ixlib=rb-4.1.0&q=85';

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (user) navigate(R.overview, { replace: true }); }, [user, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + R.overview;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="kesar-bg flex min-h-screen items-center justify-center p-4">
      <div className="grid w-full max-w-5xl overflow-hidden rounded-3xl bg-white shadow-[0_20px_70px_rgba(0,0,0,0.08)] lg:grid-cols-2">
        {/* Left visual */}
        <div className="relative hidden lg:block">
          <img src={LOGIN_BG} alt="Kesar Lands" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/30 to-transparent" />
          <div className="absolute bottom-0 p-10 text-white">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold backdrop-blur">
              <ShieldCheck className="h-3.5 w-3.5" /> Secure Internal Access
            </div>
            <h2 className="font-head text-3xl font-extrabold leading-tight">Every booking, from allotment to registry.</h2>
            <p className="mt-2 max-w-sm text-sm text-white/70">
              Bookings, inventory, legal drafting, home-loan tracking and payment recovery — unified in one lifecycle console.
            </p>
          </div>
        </div>

        {/* Right auth */}
        <div className="flex flex-col justify-center p-8 sm:p-12">
          <div className="mb-8 flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#245329] text-white shadow-[0_4px_12px_rgba(36,83,41,0.22)]">
              <Building2 className="h-7 w-7" strokeWidth={2.2} />
            </div>
            <div>
              <div className="font-head text-2xl font-extrabold tracking-tight text-stone-900">KesarOne</div>
              <div className="text-xs font-semibold uppercase tracking-[0.15em] text-stone-400">Kesar Lands</div>
            </div>
          </div>

          <h1 className="font-head text-3xl font-extrabold tracking-tight text-stone-900">Sign in to continue</h1>
          <p className="mt-2 text-sm font-medium text-stone-500">
            Access is restricted to provisioned Kesar Lands accounts only. Self-registration is disabled.
          </p>

          <button
            data-testid={AUTH.googleBtn}
            onClick={signIn}
            className="mt-8 flex w-full items-center justify-center gap-3 rounded-xl border border-stone-200 bg-white px-6 py-3.5 text-sm font-bold text-stone-700 shadow-sm transition-all hover:border-stone-300 hover:shadow-md active:scale-[0.99]"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5" />
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  );
}
